"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucks = void 0;
const sp10_1 = require("../sp10/sp10");
const Varsity_Block_A_woff_1 = __importDefault(require("./fonts/Varsity-Block-A.woff"));
const favicon_ico_1 = __importDefault(require("./logo/favicon.ico"));
const logo_png_1 = __importDefault(require("./logo/logo.png"));
const logo2_png_1 = __importDefault(require("./logo/logo2.png"));
const logo3_png_1 = __importDefault(require("./logo/logo3.png"));
const logo4_png_1 = __importDefault(require("./logo/logo4.png"));
exports.bucks = {
    ...sp10_1.sp10,
    name: "Milwaukee Bucks",
    "loading-dots-color": "#124623",
    "loading-text-color": "#fff",
    "app-logo-color-url": logo_png_1.default,
    "login-header-logo-url": logo2_png_1.default,
    "login-logo-url": logo3_png_1.default,
    "app-logo-url": logo_png_1.default,
    "app-logo-tagline-url": logo4_png_1.default,
    favicon: favicon_ico_1.default,
    "banner-background-color": "#00471B",
    "hover-color": "#0077C0",
    "app-link-color": "#00471B",
    "drawer-selected-background-color": "#000",
    "banner-tab-link-color": "#eaeef7",
    "banner-link-color": "#9ed4f9",
    "banner-active-module-link-color": "#ffffff",
    "banner-skew-background-color": "#000",
    "body-background-color": "#EEE1C6",
    "font-family": "BucksFont, Arial",
    "pane-border-color": "#000",
    "pane-header-color": "#9ed4f9",
    "pane-body-background-color": "#b7d6a4",
    "custom-css": `@font-face {
                     font-family: BucksFont;
                     font-display: auto;
                     unicode-range: U+000-5FF; /* Load only Latin glyphs */
                     src: url(${Varsity_Block_A_woff_1.default}) format('woff');
                  }
                  .banner-item-text, #drawer {
                     font-weight: normal;
                     letter-spacing: 0.04em;
                     word-spacing: -0.1em;
                  }
   `
};
//# sourceMappingURL=bucks.js.map